// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grundlegende Styles */

.events-container {
  max-width: 1400px;
  margin: 30px auto;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.events-title {
  font-size: 24px;
  margin-bottom: 20px;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  text-align: left;
  display: flex;
  align-items: center;
}

.events-input {
  width: 100%;
  padding: 10px 15px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.events-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.events-button {
  width: 100%;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.events-button:hover {
  background-color: #0056b3;
}

.events-list {
  list-style-type: none;
  padding: 0;
}

.events-item {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 10px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
}

.delete-btn {
  background-color: #f44336; /* Rot */
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 5px;
  font-family: "SawtonCircular-Medium";
  transition: background-color 0.3s;
}

.delete-btn:hover {
  background-color: #d32f2f; /* Ein dunkleres Rot beim Hover */
}

.vertical-line {
  width: 3px; /* Breite der Linie */
  height: 150px; /* Höhe der Linie - Sie können diese Zahl nach Ihren Wünschen anpassen */
  background-color: #cccccc; /* Graue Farbe */
  margin: 0 15px;
}
.events-item-Events {
  flex: 1 1; /* Damit die Event-Liste den verfügbaren Raum einnimmt */
  margin: 0;
  background: linear-gradient(
    135deg,
    #f3f3f3,
    #e6e6e6
  ); /* Ein schicker linearer Gradient als Hintergrund */
  border-radius: 15px;
  padding: 25px 35px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  margin-bottom: 25px;
  list-style-type: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer; /* Zeigt einen Handcursor an, wenn Sie mit der Maus darüberfahren */
  display: flex;
  align-items: center;
}
.event-content {
  flex: 1 1; /* Nimmt den verfügbaren Raum ein */
}
.events-item-Events:hover {
  transform: translateY(
    -5px
  ); /* Hebt das Element beim Darüberfahren leicht an */
  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.25); /* Ein tieferer Schatten beim Darüberfahren */
}

.events-item-Events h1 {
  font-size: 1.8rem;
  color: #222;
  margin-bottom: 25px;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: 3px solid #f76c6c; /* Eine untere Grenze, um den Namen hervorzuheben */
  padding-bottom: 10px; /* Platz zwischen Text und Grenze */
}

.events-item-Events div {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2px;
  letter-spacing: 0.8px; /* Ein wenig Buchstabensatz für ein verbessertes Lesen */
  line-height: 1.4; /* Verbessert die Lesbarkeit bei mehrzeiligen Texten */
}

/* Farbige Icons oder Markierungen könnten vor bestimmten Informationen eingefügt werden, um die Aufmerksamkeit zu erhöhen */
.events-item-Events div:nth-child(2) {
  color: #f76c6c; /* Diese Farbe hebt das Datum und die Uhrzeit hervor */
}

/* Responsivität für kleine Bildschirme (z.B. Mobilgeräte) */

@media (max-width: 768px) {
  .events-container {
    padding: 15px;
    box-shadow: none;
  }

  .events-input,
  .events-button {
    font-size: 14px;
  }

  .events-title {
    font-size: 20px;
  }

  .delete-btn {
    margin-left: 0; /* Entfernt den linken Rand */
    margin-top: 10px; /* Fügt einen oberen Rand hinzu */
  }
}
@media (max-width: 450px) {
  .events-item-Events {
    flex-direction: column;
  }
  .vertical-line {
    height: 2px;
    width: 100%;
    margin: 10px 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/container/Dashboard/components/Events/events.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB,EAAE,QAAQ;EACnC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,UAAU,EAAE,qBAAqB;EACjC,aAAa,EAAE,wEAAwE;EACvF,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc;AAChB;AACA;EACE,SAAO,EAAE,wDAAwD;EACjE,SAAS;EACT;;;;GAIC,EAAE,mDAAmD;EACtD,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;EACrD,eAAe,EAAE,mEAAmE;EACpF,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAO,EAAE,mCAAmC;AAC9C;AACA;EACE;;GAEC,EAAE,kDAAkD;EACrD,0CAA0C,EAAE,6CAA6C;AAC3F;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC,EAAE,mDAAmD;EACrF,oBAAoB,EAAE,mCAAmC;AAC3D;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,qBAAqB,EAAE,wDAAwD;EAC/E,gBAAgB,EAAE,sDAAsD;AAC1E;;AAEA,4HAA4H;AAC5H;EACE,cAAc,EAAE,sDAAsD;AACxE;;AAEA,4DAA4D;;AAE5D;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc,EAAE,6BAA6B;IAC7C,gBAAgB,EAAE,iCAAiC;EACrD;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* Grundlegende Styles */\r\n\r\n.events-container {\r\n  max-width: 1400px;\r\n  margin: 30px auto;\r\n  background-color: #fff;\r\n  border-radius: 5px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);\r\n  padding: 20px;\r\n}\r\n\r\n.events-title {\r\n  font-size: 24px;\r\n  margin-bottom: 20px;\r\n  border-bottom: 2px solid #eee;\r\n  padding-bottom: 10px;\r\n  text-align: left;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.events-input {\r\n  width: 100%;\r\n  padding: 10px 15px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n  font-size: 16px;\r\n}\r\n\r\n.events-input:focus {\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\r\n}\r\n\r\n.events-button {\r\n  width: 100%;\r\n  padding: 10px 15px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.events-button:hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n.events-list {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.events-item {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #f9f9f9;\r\n  padding: 10px 15px;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.delete-btn {\r\n  background-color: #f44336; /* Rot */\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  font-family: \"SawtonCircular-Medium\";\r\n  transition: background-color 0.3s;\r\n}\r\n\r\n.delete-btn:hover {\r\n  background-color: #d32f2f; /* Ein dunkleres Rot beim Hover */\r\n}\r\n\r\n.vertical-line {\r\n  width: 3px; /* Breite der Linie */\r\n  height: 150px; /* Höhe der Linie - Sie können diese Zahl nach Ihren Wünschen anpassen */\r\n  background-color: #cccccc; /* Graue Farbe */\r\n  margin: 0 15px;\r\n}\r\n.events-item-Events {\r\n  flex: 1; /* Damit die Event-Liste den verfügbaren Raum einnimmt */\r\n  margin: 0;\r\n  background: linear-gradient(\r\n    135deg,\r\n    #f3f3f3,\r\n    #e6e6e6\r\n  ); /* Ein schicker linearer Gradient als Hintergrund */\r\n  border-radius: 15px;\r\n  padding: 25px 35px;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);\r\n  margin-bottom: 25px;\r\n  list-style-type: none;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  cursor: pointer; /* Zeigt einen Handcursor an, wenn Sie mit der Maus darüberfahren */\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.event-content {\r\n  flex: 1; /* Nimmt den verfügbaren Raum ein */\r\n}\r\n.events-item-Events:hover {\r\n  transform: translateY(\r\n    -5px\r\n  ); /* Hebt das Element beim Darüberfahren leicht an */\r\n  box-shadow: 0 7px 20px rgba(0, 0, 0, 0.25); /* Ein tieferer Schatten beim Darüberfahren */\r\n}\r\n\r\n.events-item-Events h1 {\r\n  font-size: 1.8rem;\r\n  color: #222;\r\n  margin-bottom: 25px;\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n  border-bottom: 3px solid #f76c6c; /* Eine untere Grenze, um den Namen hervorzuheben */\r\n  padding-bottom: 10px; /* Platz zwischen Text und Grenze */\r\n}\r\n\r\n.events-item-Events div {\r\n  font-size: 1.1rem;\r\n  color: #666;\r\n  margin-bottom: 2px;\r\n  letter-spacing: 0.8px; /* Ein wenig Buchstabensatz für ein verbessertes Lesen */\r\n  line-height: 1.4; /* Verbessert die Lesbarkeit bei mehrzeiligen Texten */\r\n}\r\n\r\n/* Farbige Icons oder Markierungen könnten vor bestimmten Informationen eingefügt werden, um die Aufmerksamkeit zu erhöhen */\r\n.events-item-Events div:nth-child(2) {\r\n  color: #f76c6c; /* Diese Farbe hebt das Datum und die Uhrzeit hervor */\r\n}\r\n\r\n/* Responsivität für kleine Bildschirme (z.B. Mobilgeräte) */\r\n\r\n@media (max-width: 768px) {\r\n  .events-container {\r\n    padding: 15px;\r\n    box-shadow: none;\r\n  }\r\n\r\n  .events-input,\r\n  .events-button {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .events-title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .delete-btn {\r\n    margin-left: 0; /* Entfernt den linken Rand */\r\n    margin-top: 10px; /* Fügt einen oberen Rand hinzu */\r\n  }\r\n}\r\n@media (max-width: 450px) {\r\n  .events-item-Events {\r\n    flex-direction: column;\r\n  }\r\n  .vertical-line {\r\n    height: 2px;\r\n    width: 100%;\r\n    margin: 10px 0px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
